'use client'

import React, { useRef } from 'react'
import { Provider } from 'react-redux'
import { setProductViewMode } from '@/lib/redux/app-session-slice'
import { makeStore, type AppStore } from '@/lib/store'

export const dynamic = 'force-dynamic'

export function StoreProvider({ children }: { children: React.ReactNode }) {
  const storeRef = useRef<AppStore>()

  React.useEffect(() => {
    if (!storeRef.current) {
      storeRef.current = makeStore()

      // Load saved view mode from localStorage
      const savedViewMode = localStorage?.getItem('productViewMode')
      if (
        savedViewMode &&
        (savedViewMode === 'vertical' || savedViewMode === 'horizontal')
      ) {
        storeRef.current.dispatch(setProductViewMode(savedViewMode))
      }
    }
  }, [])

  if (!storeRef.current) {
    // This will only happen on the first render
    storeRef.current = makeStore()

    // Load saved view mode from localStorage on initial render
    if (typeof window !== 'undefined') {
      const savedViewMode = localStorage?.getItem('productViewMode')
      if (
        savedViewMode &&
        (savedViewMode === 'vertical' || savedViewMode === 'horizontal')
      ) {
        storeRef.current.dispatch(setProductViewMode(savedViewMode))
      }
    }
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}
